import styled from 'styled-components';
import tw from 'twin.macro';
import { motion } from 'framer-motion';
import { Body, Meta } from '../../styled components/Typography';
import SVGIcon from '../SVGIcon/SVGIcon';
import UICard from '../../styled components/UICard';
import Tag from '../../styled components/Tag';

export const NotificationTypeTag = styled(Tag)(({ variant }) => [
  tw`mr-4`,
  variant === 'release' && tw`bg-blue-base`,
  variant === 'maintenance' && tw`bg-orange-base`
]);

export const UIUpdateCard = styled(UICard)(() => tw`ring ring-blue-lighten-20`);

export const NotificationsBar = styled.div(() => [tw`relative bg-silver-lighten-30`]);

export const NotificationsList = styled.ul(() => [tw`mt-8 relative space-y-16 mb-16`]);

export const NotificationsOnDateList = styled.ul(({ $extraSpacingForOutline }) => [
  tw`space-y-8 `,
  $extraSpacingForOutline && tw`space-y-12 `
]);

export const NotificationsOnDateDateText = styled(Body).attrs(() => ({
  as: 'p',
  $textStyle: 'bold'
}))(() => [tw`mb-8`]);

export const NotificationsOnDateNotificationList = styled.ul(() => [tw`mb-0`]);

export const NotificationsOnDateNotificationsListAnimation = styled(
  motion(NotificationsOnDateNotificationList, {
    forwardMotionProps: true
  })
)(() => [tw`space-y-8`]);

export const NotificationsOnDateListItem = styled.li(() => []);

export const NotificationsOnDateListItemAnimation = styled(
  motion(NotificationsOnDateListItem, {
    forwardMotionProps: true
  })
)(() => []);

export const NotificationsListItemText = styled(Body).attrs(() => ({
  as: 'p'
}))(() => [tw`mb-8`]);

export const NotificationCenterNoContent = styled.div(() => [
  tw`text-center mt-48 mb-48`
]);

export const NotificationsWithHeaderAnimation = styled.li(() => []);

export const NotificationItemCategoryText = styled.p(({ hidden }) => [
  tw`mb-8 text-center`,
  hidden && tw`hidden`
]);

export const NotificationsListDivider = styled.div(() => [
  tw`bg-silver-lighten-10 h-px w-full shadow-white mb-8`
]);

export const NoNotificationsContainer = styled(
  motion(Body, {
    forwardMotionProps: true
  })
)(() => [
  tw`text-center text-black text-opacity-60`,
  'position: absolute;',
  'top: 0;',
  'width: 100%;',
  'opacity: 0;'
]);

export const NoNotificationsIcon = styled(SVGIcon)(() => [tw`fill-blue-base opacity-95`]);
export const NoNotificationsTitle = styled(Body).attrs(() => ({
  as: 'p',
  $textStyle: 'italic'
}))(() => [tw`text-blue-base text-opacity-95`]);
export const NoNotificationsText = styled(Meta).attrs(() => ({
  as: 'p'
}))(() => [tw`mt-8`]);
